import Vue from 'vue'
import axios from 'axios'

const api = axios.create({
	headers: { 'X-Requested-With': 'XMLHttpRequest' },
	withCredentials: true
})

api.interceptors.response.use(
	(response) => {
		return response
	},
	(error) => {
		const vm = new Vue()

		if(error.response) {
			vm.$root.$bvToast.toast(error.response.data.message, {
				title: 'Error',
				variant: 'danger'
			})
		}

		console.warn(error)

		return Promise.reject(error)
	}
)

export default api
